import React from "react";
import BokkingR from "../Components/BokkingR";
import SidebarLayout from "../Components/sidebar/SidebarLayout";

function Booking() {
  return (
    <>
      <SidebarLayout>
        <div style={{ position: "relative" }}>
          <BokkingR />
        </div>
      </SidebarLayout>
    </>
  );
}

export default Booking;
